import React from 'react';
import { Icon, Dropdown, Button } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { presentationOptions } from '@/constants/states';
import { toggleCollectionsPresentation, toggleCollectionsSingleSorting } from '../actions';

const CollectionsTableSettingsMenu = ({
  category,
  singleSorting,
  togglePresentation,
  toggleSingleSorting,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      icon={null}
      pointing="top left"
      trigger={(
        <Button
          basic
          title={intl.formatMessage({ id: 'actions.table.settings.title' })}
          icon="cog"
          className="aridhia-collections-table-settings-menu-button"
          circular
        />
      )}
      className="aridhia-collections-table-settings-menu"
    >
      <Dropdown.Menu>
        <Dropdown.Item
          as="a"
          selected={false}
          onClick={() => toggleSingleSorting(category)}
        >
          <Icon name="sort alphabet down" />
          <FormattedMessage id={singleSorting ? 'actions.sort.multiple' : 'actions.sort.single'} />
        </Dropdown.Item>
        <Dropdown.Item
          as="a"
          selected={false}
          onClick={() => togglePresentation(category, presentationOptions.CARDS)}
        >
          <Icon name="grid layout" />
          <FormattedMessage id="actions.display.cards" />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const mapStateToProps = ({
  collections: { collections },
}, { category }) => {
  const { singleSorting } = collections[category];
  return ({ singleSorting });
};

const mapDispatchToProps = {
  toggleSingleSorting: toggleCollectionsSingleSorting,
  togglePresentation: toggleCollectionsPresentation,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionsTableSettingsMenu);
